// «Заявки подбора»: статус и этап подбора по маршруту. Только показ, на KPI не влияет.
import { useEffect, useState } from 'react';
import { supabase } from './supabase';

export async function loadRecruitingFile(rows, actorId) {
  const { data, error } = await supabase.rpc('load_recruiting', { p_rows: rows, p_actor: actorId });
  if (error) throw new Error(error.message);
  return data;
}

// Таблица маленькая (сотни строк): грузим целиком один раз и делим между всеми плашками.
let cache = null, cacheAt = 0, inflight = null;
const subs = new Set();

async function fetchAll() {
  const { data, error } = await supabase.from('route_recruiting')
    .select('vacancy_id, route_id, status, stage, suspend_reason, recruiter, opened_at, stage_since').not('route_id', 'is', null).limit(5000);
  if (error) throw new Error(error.message);
  const map = {};
  (data || []).forEach(r => { (map[r.route_id] = map[r.route_id] || []).push(r); });
  return map;
}

export function refreshRecruiting() {
  if (!inflight) {
    inflight = fetchAll().then(m => { cache = m; cacheAt = Date.now(); subs.forEach(f => f(m)); return m; })
      .catch(() => cache || {}).finally(() => { inflight = null; });
  }
  return inflight;
}

// map: { [route_id]: [{status, stage, ...}] }; ошибка/нет таблицы = пустая карта
export function useRecruiting() {
  const [map, setMap] = useState(cache || {});
  useEffect(() => {
    subs.add(setMap);
    if (!cache || Date.now() - cacheAt > 5 * 60 * 1000) refreshRecruiting();
    return () => { subs.delete(setMap); };
  }, []);
  return map;
}
